import React from "react";
import { Navigate, Route } from "react-router-dom";
import { FINANCE_ROLES } from "../constants/roles";
import AppShell from "../layout/AppShell";
import RequireRoles from "../layout/RequireRoles";
import { FINANCE_NAV } from "./nav-config";
import FinanceOrdersPage from "./pages/orders";
import FinanceQuotationsPage from "./pages/quotations";
import FinanceRefundsPage from "./pages/refunds";
import FinanceCodPage from "./pages/cod";
// Users + User Details — the legacy /users and /user/:id screens, mounted unchanged in
// every console. The users table links to `<current path>/:id`, so a row click stays in
// this console instead of jumping to the legacy /user/:id route.
import { Users } from "../../pages/users";
import UserDetails from "../../pages/user-details";

// Finance Console (`.scratch/finance-dashboard/IMPLEMENTATION.md`) — a top-level console
// at /v2/finance/*, a sibling of /v2/ops and /v2/pharmacy rather than a section inside
// one of them.
//
// The four tabs read the SAME order/payment/quotation data the pharmacist console reads,
// through the SAME admin endpoints (§5.5: extend them, never a second query). What
// differs is audience and task — reconciliation rather than fulfilment — which is why it
// gets its own shell and its own nav rather than a seventh entry in the pharmacy sidebar.
//
// Orders is the landing screen: it is the widest view and the one the other three are
// usually reached from.
//
// ROLES: FINANCE_ROLES throughout. These pages once ran on PHARMACY_ROLES, a placeholder
// from when they were mounted under /v2/pharmacy; that is why every pharmacist saw a
// Finance tab. Repointed 2026-09-24, in step with consoles.js and nav-config.js.
// OLD NOTE (no longer true), carried over from when these pages
// lived under /v2/pharmacy. §6 of the spec defers the access-control decision, and
// promoting Finance to its own console sharpens the question — a finance team that is not
// the pharmacy team currently cannot reach these screens, and anyone with pharmacy access
// can. Flagged for the product owner, not resolved here.
export const FINANCE_ROUTES = (
    <Route path="/v2/finance" element={<AppShell nav={FINANCE_NAV} />}>
        <Route index element={<Navigate to="orders" replace />} />
        <Route
            path="orders"
            element={
                <RequireRoles roles={FINANCE_ROLES}>
                    <FinanceOrdersPage />
                </RequireRoles>
            }
        />
        <Route
            path="quotations"
            element={
                <RequireRoles roles={FINANCE_ROLES}>
                    <FinanceQuotationsPage />
                </RequireRoles>
            }
        />
        <Route
            path="refunds"
            element={
                <RequireRoles roles={FINANCE_ROLES}>
                    <FinanceRefundsPage />
                </RequireRoles>
            }
        />
        <Route
            path="cod"
            element={
                <RequireRoles roles={FINANCE_ROLES}>
                    <FinanceCodPage />
                </RequireRoles>
            }
        />
        <Route
            path="users"
            element={
                <RequireRoles roles={FINANCE_ROLES}>
                    <Users />
                </RequireRoles>
            }
        />
        <Route
            path="users/:id"
            element={
                <RequireRoles roles={FINANCE_ROLES}>
                    <UserDetails />
                </RequireRoles>
            }
        />
    </Route>
);
